import initialState from './initialState'
import {FETCH_ALLOCATIONS, RECEIVE_ALLOCATIONS} from '../actions/actionTypes'

export default function allocations(state = initialState.allocations, action) {
	let newState
	switch (action.type) {
	case FETCH_ALLOCATIONS:
		return {
			...action,
			isFetching: true
		}
	case RECEIVE_ALLOCATIONS:
		newState = action.allocations
		return {
			...newState,
			isFetching: false
		}
	default:
		return state
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/allocations.js